import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_7: FaireProductEntity = {
  token: "toysmith-7",
  type: "product",
  name: "Outdoor Discovery Wildlife Tent Projector, Includes 5 Slides",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/5fb7f73653555a7d33e34f5bd2cde97ebdfc19969445a639050174245d5aee8d.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 16,
  msrpDollars: 32,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
